/************************************
MODULE:         Blog feed
WHAT IT DOES:   Encapsulates feed layout
*************************************/
(function (root, factory) {
    if (typeof define === 'function' && define.amd) {
        define(['jquery'], factory);
    }
    else if (typeof exports === 'object') {
        module.exports = factory(require('jquery'));
    }
    else { root.returnExports = factory(root.jQuery); }
}(this, function ($) {

    function socialfeed(el, settings) {
        this.container = el;

        $.extend(this, this._defaults);
        this.settings = $.extend({}, this._settings, this.container.data(), typeof settings != 'undefined' ? settings : {});

        this.init();
    }

    $.extend(socialfeed.prototype, {

        _settings: {
            sizeBig:'big',
            sizeWide: 'wide',
            sizeSmall: 'small',
            template: 'single triple tripleReversed single quaternary triple',
            handlebarsTemplate: 'blogfeedtemplate',
            url: '',
            page: 0,
            total: 0,
            mintimeout: 1500
        },

        _defaults: {
            grid: null,
            items: null,
            filter: null,
            filterdropdown: null,
            filterChosen: '',
            loadmore: null,
            template: null,
            bigItems: null,
            wideItems: null,
            smallItems: null,
            ajaxCall: null,
            ajaxTime: null,
            ajaxTimeout: null,
            handlebarsTempalteCompiled: null
        },

        types: {
            'single': 0,
            'triple': 1,
            'double': 2,
            'tripleReversed' : 3,
            'quaternary': 4
        },

        init: function () {
            this.grid = this.container.find('.js-feed-grid');
            if(!this.grid.length)
                return;

            this.items = this.grid.children();
            this.template = this.settings.template.split(' ');

            var templates = require.context("../../../templates/handlebars/", true, /^\.\/.*\.handlebars$/);
            this.handlebarsTempalteCompiled = templates("./" + this.settings.handlebarsTemplate + ".handlebars");

            this.loadmore = this.container.find('.js-feed-loadmore');
            this.loadmore.on('click', this.loadNewItems.bind(this, false));

            this.filter = this.container.parent().find(".js-feed-filter");
            if (this.filter.length) {
                this.filter.on('click', 'a', this.applyFilter.bind(this));
                this.filterdropdown = this.container.parent().find('.js-feed-filterdropdown');

                var activeLink = this.filter.find('a.active');
                if (activeLink.length) {
                    var chosen = activeLink.attr('data-filter') || '';
                    if (chosen !== this.filterChosen)
                        this.filterChosen = chosen;
                }

                var genericdropdown = require('generic.dropdown');
                new genericdropdown(this.filterdropdown, {
                    link: this.filterdropdown.find('.js-dropdown-link'),
                    content: this.filterdropdown.find('.js-dropdown-content'),
                    erase: true
                });
            }

            require('imports?this=>global!jquery.dotdotdot');

            this.layout();
            $(window).on('resize:finished', this.layout.bind(this));
            document.addEventListener('visibilitychange', this.onVisibilitychanged.bind(this));
        },

        onVisibilitychanged: function() {
            var that = this;
            if (document.visibilityState === 'visible') {
                setTimeout(function() {
                    that.layout();
                }, 500);

            }
        },

        applyFilter: function (e) {
            if (typeof e != 'undefined' && typeof e.preventDefault == "function")
                e.preventDefault();

            var link = $(e.target);
            if (!link.length)
                link = link.parents('a');

            if (link.hasClass('active'))
                return;

            this.filter.find('a').removeClass('active');
            link.addClass('active');

            var filter = link.attr('data-filter');

            this.filterChosen = filter ? filter : '';
            this.loadNewItems(true);

            this.filterdropdown.trigger('dropdown:close');
        },

        layout: function () {
            //number of columns depend on current screen size
            var width = this.grid.outerWidth(),
                current = {
                    x: 0,
                    y: 0,
                    ymax: 0
                },
                counter = 0;

            this.bigItems = this.items.filter('[data-size=' + this.settings.sizeBig + ']').toArray();
            this.wideItems = this.items.filter('[data-size=' + this.settings.sizeWide + ']').toArray();
            this.smallItems = this.items.filter('[data-size=' + this.settings.sizeSmall + ']').toArray();

            this.items.css({
                position: 'absolute',
                display: ''
            });

            while (this.bigItems.length || this.wideItems.length || this.smallItems.length) {
                var type = this.template[counter % this.template.length];
                current = this.setItem[type].call(this, current, width);
                counter++;
            }

            TweenMax.fromTo(this.grid, 0.5, { height: this.grid.outerHeight() }, { height: current.ymax });


            var texts = this.grid.find('.feed__item-text');
            texts.filter('.js-dotted').trigger("destroy");
            texts.addClass('js-dotted');
            texts.dotdotdot();
        },

        setItem: {
            'single': function (current, width) {
                if (!this.bigItems.length)
                    return this.setItem['quaternary'].call(this, current, width);

                var item = $(this.bigItems.splice(0, 1)),
                    itemWidth = item.outerWidth(true),
                    itemHeight = item.outerHeight(true);

                item.css({
                    top: current.y + 'px',
                    left: current.x + 'px'
                });

                return this.increaseCurrent(current, width, itemWidth, itemHeight);
            },
            'double': function (current, width) {
                if (this.smallItems.length >= 2 && this.wideItems.length) {
                    return this.setItem['triple'].call(this, current, width);
                } else if (this.wideItems.length < 2 && this.bigItems.length) {
                    return this.setItem['single'].call(this, current, width);
                } if (!this.wideItems.length) {
                    return this.setItem['quaternary'].call(this, current, width);
                }

                var items = this.wideItems.splice(0, 2),
                    itemWidth = $(items[0]).outerWidth(true),
                    itemHeight = $(items[0]).outerHeight(true);

                for (var i = 0, l = items.length; i < l; i++) {
                    $(items[i]).css({
                        top: current.y + i * itemHeight + 'px',
                        left: current.x + 'px'
                    });
                }

                return this.increaseCurrent(current, width, itemWidth, items.length==1 ? itemHeight : itemHeight * 2);

            },
            'triple': function (current, width, reversed) {
                if (this.smallItems.length < 2 && this.wideItems.length >= 2) {
                    return this.setItem['double'].call(this, current, width);
                }
                if (!this.wideItems.length) {
                    return this.setItem['quaternary'].call(this, current, width);
                }

                var items = this.smallItems.splice(0, 2),
                    wideItem = $(this.wideItems.splice(0, 1)),
                    itemWidth = $(items[0]).outerWidth(true) || wideItem.outerWidth(true)/2,
                    itemHeight = $(items[0]).outerHeight(true) || wideItem.outerHeight(true);

                wideItem.css({
                    top: current.y + (reversed && items.length ? itemHeight : 0 ) + 'px',
                    left: current.x + 'px'
                });

                for (var i = 0, l = items.length; i < l; i++) {
                    $(items[i]).css({
                        top: current.y + (reversed ? 0 : itemHeight) + 'px',
                        left: current.x + itemWidth*i + 'px'
                    });
                }

                return this.increaseCurrent(current, width, itemWidth * 2, !items.length ? itemHeight : itemHeight * 2);

            },
            'tripleReversed': function (current, width) {
                return this.setItem['triple'].call(this, current, width, true);
            },
            'quaternary': function (current, width) {
                if (this.smallItems.length < 4) {
                    if (this.wideItems.length && this.smallItems.length >= 2)
                        return this.setItem['triple'].call(this, current, width);
                    else if (this.wideItems.length > 1) {
                        return this.setItem['double'].call(this, current, width);
                    } else if (this.bigItems.length) {
                        return this.setItem['single'].call(this, current, width);
                    } else if (!this.smallItems.length) {
                        return current;
                    }
                }

                var items = this.smallItems.splice(0, 4),
                    itemWidth = $(items[0]).outerWidth(true),
                    itemHeight = $(items[0]).outerHeight(true);


                for (var i = 0, l = items.length; i < l; i++) {
                    $(items[i]).css({
                        top: current.y + itemHeight*(i<2 ? 0 : 1) + 'px',
                        left: current.x + itemWidth * (i % 2) + 'px'
                    });
                }

                return this.increaseCurrent(current, width, itemWidth * 2, items.length <=2 ? itemHeight : itemHeight * 2);
            }

        },
        increaseCurrent: function (current, width, itemWidth, itemHeight) {
            current.x = current.x + itemWidth;

            if (current.x >= width - 1) {
                current.ymax = Math.max(current.ymax, current.y + itemHeight);
                current.x = 0;
                current.y = current.ymax;
            } else {
                current.ymax = current.y + itemHeight;
            }
            return current;
        },
        loadNewItems: function (isnew, e) {
            if (typeof e != 'undefined' && typeof e.preventDefault == "function")
                e.preventDefault();

            if (!this.settings.url.length)
                return;

            if (typeof isnew == 'undefined')
                isnew = false;

            if (isnew) {
                this.settings.page = 1;
            };

            var data = {
                page: this.settings.page,
                bigCount: isnew ? 0 : this.items.filter('[data-size=' + this.settings.sizeBig + ']').length,
                wideCount: isnew ? 0 : this.items.filter('[data-size=' + this.settings.sizeWide + ']').length,
                smallCount: isnew ? 0 : this.items.filter('[data-size=' + this.settings.sizeSmall + ']').length
            }

            if (this.filterChosen.length) {
                data["filter"] = this.filterChosen;
            }

            this.grid.addClass(isnew ? 'loading-all' : 'loading');
            this.ajaxAbort();

            this.ajaxCall = $.ajax({
                method: "POST",
                url: this.settings.url,
                dataType: "json",
                data: data,
                success: this.ajaxSuccess.bind(this),
                error: this.ajaxError.bind(this)
            });

        },
        ajaxSuccess: function (data) {
            var newDate = new Date(),
                diff = newDate - this.ajaxTime;
            if (diff < this.settings.mintimeout) {
                setTimeout(this.ajaxSuccess.bind(this, data), this.settings.mintimeout - diff + 1);
                return;
            }

            var isnew = this.grid.hasClass('loading-all'),
                newPageId = data.page;
            if (newPageId != this.settings.page + 1)
                return;
            this.settings.page = newPageId;
            if (typeof data.total != 'undefined')
                this.settings.total = data.total;

            this.grid.removeClass('loading loading-all');


            this.grid[isnew ? 'html' : 'append']($(this.handlebarsTempalteCompiled(data)));
            this.items = this.grid.children();
            this.afterContentUpdate();

            this.loadmoreCheck();
            this.layout();
            this.translateText();
        },

        ajaxError: function () {
            this.grid.removeClass('loading loading-all');
        },

        ajaxAbort: function () {
            if (this.ajaxCall && typeof this.ajaxCall.abort == "function") {
                try {
                    ajaxCall.abort();
                } catch (ex) { }
            }
            if (this.ajaxTimeout)
                clearTimeout(ajaxTimeout);
            this.ajaxTime = new Date();
        },
        loadmoreCheck: function () {
            if (this.settings.page > this.settings.total) {
                this.loadmore.hide();
            } else {
                this.loadmore.show();
            }
        },
        afterContentUpdate: function () {
            $(window).trigger('video:init');
        },
        translateText: function () {
            var $translateElemList = $('.js-translate');
            var arrElemToTranslate = [];
            $translateElemList.each( function (i,e) {
                e.classList.forEach( function (e) {
                    if (e.match(/js-translate-/) && (arrElemToTranslate.indexOf(e) === -1)) arrElemToTranslate.push(e);
                })
            });

            arrElemToTranslate.forEach( function (e) {
                var $loadMoreElem = $('.' + e);
                var loadMoreText = '';
                $loadMoreElem.each( function (i, e) {
                    if (e.innerText) {
                        if (!e.innerText.match(/^\{\$/)) loadMoreText = e.innerText;
                        else e.innerText = loadMoreText;
                    }
                });
            });
        }
    });

    return socialfeed

}));



/*****************
 ** WEBPACK FOOTER
 ** ./js/app/generic/generic.feed.js
 ** module id = 24
 ** module chunks = 0
 **/